// 根据环境变量动态设置API地址
// 开发环境: npm run serve (使用 .env.development)
// 生产环境: npm run build (使用 .env.production)

const isDevelopment = process.env.NODE_ENV === 'development'

export const CLIENT_API = process.env.VUE_APP_CLIENT_API || 'https://xctrader.com'
export const ADMIN_API = process.env.VUE_APP_ADMIN_API || 'https://xctrader.com/admin'

// 控制台输出当前环境和API地址，便于调试
if (isDevelopment) {
    console.log('🚀 Environment:', process.env.NODE_ENV)
    console.log('📡 CLIENT_API:', CLIENT_API)
    console.log('📡 ADMIN_API:', ADMIN_API)
}
